import {
  type QueryKey,
  type UseQueryOptions as UseQueryReactOptions,
  useQuery as useQueryReact,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { defaultQueryOptions } from '../default-query-options';

export type UseQueryOptions<
  TQueryFunctionData,
  TError extends AxiosError = AxiosError,
  TData = TQueryFunctionData,
  TQueryKey extends QueryKey = QueryKey,
> = UseQueryReactOptions<TQueryFunctionData, TError, TData, TQueryKey>;

export const useQuery = <
  TQueryFunctionData,
  TError extends AxiosError = AxiosError,
  TData = TQueryFunctionData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFunctionData, TError, TData, TQueryKey>,
) =>
  useQueryReact<TQueryFunctionData, TError, TData, TQueryKey>({
    ...defaultQueryOptions,
    ...options,
  });
